import { FC } from 'react';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';

interface ITitle {
  title: string | boolean;
}

export const DashboardTitle: FC<ITitle> = ({ title, children }) => {
  return (
    <Box py={2} display="flex">
      <Typography component="h2" sx={{ fontSize: 24, fontWeight: 400 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
};

